import Text from './Text';
import styled, { css } from 'styled-components';

const BulletText = styled(Text)`
  padding-left: 25px;
  padding-top: 5px;
  position: relative;
  ${({ theme: { isRTL } }) =>
    isRTL &&
    css`
      direction: rtl;
      padding-right: 25px;
    `}
`;

export default BulletText;
